import script from "./Salon.vue?vue&type=script&setup=true&lang=js"
export * from "./Salon.vue?vue&type=script&setup=true&lang=js"

import "./Salon.vue?vue&type=style&index=0&id=5eed88fd&scoped=true&lang=css"

import exportComponent from "/home/kuzma/www/barberteam/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5eed88fd"]])

export default __exports__